// extracted by mini-css-extract-plugin
module.exports = {"component":"ModalBackground_component__c26i_"};